import { FC } from 'react';

import { Box, CloseButton, Group, Loader, Stack, Text } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { CompanyProfile } from 'models';

import { Avatar } from 'components/avatar/Avatar';
import { Logo } from 'components/company-profile-teaser/components/Logo';
import { useCurrentUser } from 'hooks/use-current-user';
import { useSupportCompany } from 'hooks/use-support-company';

const ConnectingWithCompany: FC<ContextModalProps<{ company?: CompanyProfile }>> = ({ context, id, innerProps }) => {
    const { company } = innerProps;
    const user = useCurrentUser();
    const { company: supportCompany } = useSupportCompany();
    const target = company ?? supportCompany;

    return (
        <Box pos="relative" p="md">
            <CloseButton
                size="sm"
                pos="absolute"
                top={0}
                right={0}
                onClick={() => context.closeModal(id)}
                aria-label="Cancel"
            />
            <Stack align="center" gap="md">
                <Group gap="md" wrap="nowrap">
                    <Avatar user={user} size={48} radius="xl" />
                    <Loader type="dots" color="blue" size="sm" />
                    {target && <Logo company={target} size={48} withBorder />}
                </Group>
                <Text fz="sm" fw={500} ta="center">
                    {company ? `Connecting you with ${company.name}…` : 'Connecting you with our experts...'}
                </Text>
            </Stack>
        </Box>
    );
};

export { ConnectingWithCompany };
